import React from 'react'
import "./style.css"
import { useGetALLServiceArea } from "./../../hooks/service-area.js"
import { Button, Tag } from "antd";
import Map from './Map';
import moment from 'moment';

const ServiceArea = ({ setEditableData }) => {
  const { areas, loading, loadData } = useGetALLServiceArea();

  if (loading) {
    return <>Loading</>
  }

  return (
    <>
    <Button 
      onClick={e=> {
              loadData();
      }}>
      Refresh
    </Button>

      {areas && areas.map(area =>
        <div key={`${area.id}-area`} className="area-list-item">
          <div>

            <p><strong>{area?.area_name}</strong></p>
            <p>Lat : {area?.srv_center_lat}</p>
            <p>Lng : {area?.srv_center_lng}</p>
            <p>Expanded : {area?.expand_area_range} Meters </p>
            <p>In Charge : {area?.in_charge_name}</p>
            <p>Office Phone: {area?.office_phone}</p>
            <p>Office Address: {area?.office_address}</p>
            <p>Email: {area?.email}</p>
            <p>Start Time: {moment(area?.zone_start_time).format("h:mm A")}</p>
            <p>End Time: {moment(area?.zone_close_time).format("h:mm A")}</p>
            <p>Zone Off Reason: {area?.reason}</p>
            <p>Zone Type: {area?.zone_type}</p>
            <p>Auto Zone ON/OFF: {area?.autometic_on_off?<Tag>ON</Tag>:<Tag>OFF</Tag>}</p>
            <br />
            <p> Base Fare : {area?.base_fare}</p>
            <p> Per KM Fare : {area?.per_km_fare}</p>
            <br />
            <p>Status : {area?.active_status ? <Tag color='green'>Active</Tag> : <Tag color='red'>In-Active</Tag>}</p>
            <button onClick={_ => setEditableData(area)} type="button" className="btn btn-sm btn-primary">Edit</button>
          </div>
          <div style={{ width: '200px', height: '200px' }}>
            <Map lat={area?.srv_center_lat} lng={area?.srv_center_lng} range={area?.expand_area_range} />
          </div>
        </div>)}

    </>
  )
}

export default ServiceArea
